var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"language-image btn btn-empty",on:{"click":_vm.changeLanguage}},[_c('img',{attrs:{"width":"30","height":"20","alt":_vm.$i18n.locale+' language',"src":require('@/assets/landing/images/lang/'+_vm.srcLocale+'.svg')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }